"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiService = void 0;
const qs_1 = __importDefault(require("qs"));
const axios_1 = __importDefault(require("axios"));
const constants_1 = __importDefault(require("./constants"));
const token_service_1 = require("./token.service");
class ApiService {
    constructor(config) {
        this.config = config;
        this.axiosInstance = this.http();
    }
    get(path, query, config = {}) {
        const url = this.resolveUrl(path, query);
        return this.axiosInstance.get(url, config);
    }
    put(path, body) {
        const url = this.resolveUrl(path);
        return this.axiosInstance.put(url, body);
    }
    post(path, body = {}, config = {}) {
        const url = this.resolveUrl(path);
        return this.axiosInstance.post(url, body, config);
    }
    delete(path) {
        const url = this.resolveUrl(path);
        return this.axiosInstance.delete(url);
    }
    http() {
        const { config } = this;
        let { baseURL, bucketId, bucketSecretKey, authorization } = config;
        if (!authorization) {
            const tokenService = new token_service_1.TokenService();
            authorization = tokenService.get();
        }
        const instance = axios_1.default.create({
            baseURL
        });
        instance.interceptors.request.use(config => {
            if (bucketId) {
                config.headers[constants_1.default.BUCKET_ID_NAME] = bucketId;
            }
            if (bucketSecretKey) {
                config.headers[constants_1.default.BUCKET_SECRET_NAME] = bucketSecretKey;
            }
            if (authorization) {
                config.headers[constants_1.default.AUTHORIZATION_TOKEN_ALTERNATE_NAME] = authorization;
            }
            if (authorization) {
                config.headers[constants_1.default.AUTHORIZATION_TOKEN_NAME] = authorization;
            }
            return config;
        });
        instance.interceptors.response.use((response) => {
            //return response.data ? response.data : response;
            return response;
        }, (error) => {
            const { response } = error;
            if (response && response.data) {
                Object.assign(error, response.data);
            }
            return Promise.reject(error);
        });
        return instance;
    }
    resolveUrl(url, query) {
        const path = this.getPath(url);
        const segments = [path];
        if (query) {
            const queryString = this.getQueryString(query);
            segments.push(queryString);
        }
        return segments.join("?");
    }
    getQueryString(query) {
        const { where } = query, rest = __rest(query, ["where"]);
        const params = Object.assign({}, rest, where);
        return decodeURIComponent(qs_1.default.stringify(params));
    }
    getPath(path) {
        if (Array.isArray(path)) {
            path = path.join('/');
        }
        return path;
    }
}
exports.ApiService = ApiService;
//# sourceMappingURL=api.service.js.map